import { createAsyncThunk } from '@reduxjs/toolkit'
import { ResolveUrl } from 'features/firebase-app'
import { getBearerToken } from '../../application/application-slice'

export const get_content_houses_for_customer = createAsyncThunk<any, any, any>(
  'auto/get/content/houses/for/customer',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      try {
        let response = await fetch(
          ResolveUrl('auto/get/content/houses/for/customer'),
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${bearToken}`,
              'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify(params),
          },
        )
        let res = await response.json()
        if (params && params.callback) {
          params.callback(true, res)
        }

        return res
      } catch (e) {
        if (params && params.callback) {
          params.callback(false, e)
        }
      }
    } else {
      if (params && params.callback) {
        params.callback(false)
      }
      throw 'not signed in'
    }
  },
)

export const get_media_for_customer = createAsyncThunk<any, any, any>(
  'auto/get/media/for/customer',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      try {
        let response = await fetch(ResolveUrl('auto/get/media/for/customer'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearToken}`,
            'Access-Control-Allow-Origin': '*',
          },
          body: JSON.stringify(params),
        })
        let res = await response.json()
        if (params && params.callback) {
          params.callback(true, res)
        }

        return res
      } catch (e) {
        if (params && params.callback) {
          params.callback(false, e)
        }
      }
    } else {
      if (params && params.callback) {
        params.callback(false)
      }
      throw 'not signed in'
    }
  },
)

export const store_coherent_screen_for_customer = createAsyncThunk<
  any,
  any,
  any
>(
  'auto/store/conherent/screen/for/customer',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      try {
        let response = await fetch(
          ResolveUrl('auto/store/conherent/screen/for/customer'),
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${bearToken}`,
              'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify(params),
          },
        )
        let res = await response.json()
        if (params && params.callback) {
          params.callback(true, res)
        }

        return res
      } catch (e) {
        if (params && params.callback) {
          params.callback(false, e)
        }
      }
    } else {
      if (params && params.callback) {
        params.callback(false)
      }
      throw 'not signed in'
    }
  },
)

export const get_customer_coherent_screens = createAsyncThunk<any, any, any>(
  'auto/get/customer/coherent/screens',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      try {
        let response = await fetch(
          ResolveUrl('auto/get/customer/coherent/screens'),
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${bearToken}`,
              'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify(params),
          },
        )
        let res = await response.json()
        if (params && params.callback) {
          params.callback(true, res)
        }

        return res
      } catch (e) {
        if (params && params.callback) {
          params.callback(false, e)
        }
      }
    } else {
      if (params && params.callback) {
        params.callback(false)
      }
      throw 'not signed in'
    }
  },
)

export const delete_customer_coherent_screens = createAsyncThunk<any, any, any>(
  'auto/delete/customer/coherent/screens',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      try {
        let response = await fetch(
          ResolveUrl('auto/delete/customer/coherent/screens'),
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${bearToken}`,
              'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify(params),
          },
        )
        let res = await response.json()
        if (params && params.callback) {
          params.callback(true, res)
        }

        return res
      } catch (e) {
        if (params && params.callback) {
          params.callback(false, e)
        }
      }
    } else {
      if (params && params.callback) {
        params.callback(false)
      }
      throw 'not signed in'
    }
  },
)

export const assign_customer_coherent_screen = createAsyncThunk<any, any, any>(
  'auto/assign/customer/coherent/screen',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      try {
        let response = await fetch(
          ResolveUrl('auto/assign/customer/coherent/screen'),
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${bearToken}`,
              'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify(params),
          },
        )
        let res = await response.json()
        if (params && params.callback) {
          params.callback(true, res)
        }

        return res
      } catch (e) {
        if (params && params.callback) {
          params.callback(false, e)
        }
      }
    } else {
      if (params && params.callback) {
        params.callback(false)
      }
      throw 'not signed in'
    }
  },
)

export const get_customer_curated_media_lists = createAsyncThunk<any, any, any>(
  'auto/get/customer/curated/media/lists',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      try {
        let response = await fetch(
          ResolveUrl('auto/get/customer/curated/media/lists'),
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${bearToken}`,
              'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify(params),
          },
        )
        let res = await response.json()
        if (params && params.callback) {
          params.callback(true, res)
        }

        return res
      } catch (e) {
        if (params && params.callback) {
          params.callback(false, e)
        }
      }
    } else {
      if (params && params.callback) {
        params.callback(false)
      }
      throw 'not signed in'
    }
  },
)

export const get_customer_settings_as_customer = createAsyncThunk<
  any,
  any,
  any
>(
  'auto/get/customer/settings/as/customer',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      try {
        let response = await fetch(
          ResolveUrl('auto/get/customer/settings/as/customer'),
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${bearToken}`,
              'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify(params),
          },
        )
        let res = await response.json()
        if (params && params.callback) {
          params.callback(true, res)
        }

        return res
      } catch (e) {
        if (params && params.callback) {
          params.callback(false, e)
        }
      }
    } else {
      if (params && params.callback) {
        params.callback(false)
      }
      throw 'not signed in'
    }
  },
)

export const get_customer_administrator_as_customer = createAsyncThunk<
  any,
  any,
  any
>(
  'auto/get/customer/administrator/as/customer',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      try {
        let response = await fetch(
          ResolveUrl('auto/get/customer/administrator/as/customer'),
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${bearToken}`,
              'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify(params),
          },
        )
        let res = await response.json()
        if (params && params.callback) {
          params.callback(true, res)
        }

        return res
      } catch (e) {
        if (params && params.callback) {
          params.callback(false, e)
        }
      }
    } else {
      if (params && params.callback) {
        params.callback(false)
      }
      throw 'not signed in'
    }
  },
)

export const get_curated_media_list_for_user = createAsyncThunk<any, any, any>(
  'auto/get/curated/media/list/for/user',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      try {
        let response = await fetch(
          ResolveUrl('auto/get/curated/media/list/for/user'),
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${bearToken}`,
              'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify(params),
          },
        )
        let res = await response.json()
        if (params && params.callback) {
          params.callback(true, res)
        }

        return res
      } catch (e) {
        if (params && params.callback) {
          params.callback(false, e)
        }
      }
    } else {
      if (params && params.callback) {
        params.callback(false)
      }
      throw 'not signed in'
    }
  },
)
